import Button from '@mui/material/Button';
import TfHighlights from 'components/Tools/BlogNameGenerator/TfHighlights';
import { getUser } from 'helpers/token';
import React, { useEffect, useState } from 'react';
import Image from 'components/Image';
import earnHiveImg from 'images/earnHive.svg';
import adsImg from 'images/ads.svg';
import affiliateImg from 'images/affiliate.svg';
import { allLandingPosts } from 'contentlayer/generated';
import MDX from 'components/HelpCenter/MDX';

export default function Monetization() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    setUser(getUser());
  }, []);

  const post = allLandingPosts.find(
    post => post.slug === 'landing/monetization',
  );

  return (
    <>
      <section className="tw-py-10 sm:tw-py-16 lg:tw-py-24">
        <div className="tw-px-4 tw-mx-auto tw-max-w-7xl sm:tw-px-6 lg:tw-px-8">
          <div className="tw-max-w-2xl tw-mx-auto tw-text-center">
            <h1 className="tw-text-3xl tw-font-black tw-leading-tight tw-text-gray-800 dark:tw-text-gray-100 sm:tw-text-4xl">
              How To Make Money With a Travel Blog
            </h1>
            <p className="tw-text-lg tw-pt-4 tw-text-gray-700 dark:tw-text-gray-300">
              Travel. Write. Earn. Discover ways to monetize your travel tales.
            </p>
          </div>

          <div className="tw-grid tw-grid-cols-1 tw-mt-12 lg:tw-mt-24 tw-gap-y-12 md:tw-grid-cols-3 tw-gap-x-6">
            <div className="md:tw-px-4 lg:tw-px-10">
              <Image
                priority
                alt="Affiliate Marketing"
                src={affiliateImg}
                className="tw-max-h-56"
                height={400}
              />
              <h3 className="tw-mt-8 tw-text-xl tw-font-semibold tw-leading-tight tw-text-gray-900 dark:tw-text-gray-100">
                Affiliate Marketing
              </h3>
              <p className="tw-mt-4 tw-text-base tw-text-gray-600 dark:tw-text-gray-400">
                Partner with brands and earn commissions for every sale made
                through your referral. It&apos;s a win-win for you and your
                readers who are looking for travel recommendations.
              </p>
              <a href="#affiliate-marketing">
                <Button className="tw-normal-case" variant="outlined">
                  Learn more about Affiliate Marketing
                </Button>
              </a>
            </div>
            <div className="md:tw-px-4 lg:tw-px-10">
              <Image
                priority
                alt="Advertising"
                src={adsImg}
                className="tw-max-h-56"
                height={580}
              />
              <h3 className="tw-mt-8 tw-text-xl tw-font-semibold tw-leading-tight tw-text-gray-900 dark:tw-text-gray-100">
                Advertising
              </h3>
              <p className="tw-mt-4 tw-text-base tw-text-gray-600 dark:tw-text-gray-400">
                Display ads on your blog and get paid for every click or
                impression. It&apos;s a passive way to generate income while you
                focus on creating content.
              </p>
              <a href="#display-advertising">
                <Button className="tw-normal-case" variant="outlined">
                  Learn how to set up AdSense
                </Button>
              </a>
            </div>

            <div className="md:tw-px-4 lg:tw-px-10">
              <Image
                priority
                alt="Hive blockchain"
                src={earnHiveImg}
                height={376}
              />
              <h3 className="tw-mt-8 tw-text-xl tw-font-semibold tw-leading-tight tw-text-gray-900 dark:tw-text-gray-100">
                Hive
              </h3>
              <p className="tw-mt-4 tw-text-base tw-text-gray-600 dark:tw-text-gray-400">
                Cross-post your content to the Hive social network, earn rewards
                based on popularity. A fresh avenue to reach more readers and
                monetize content.
              </p>
              <a href="#cross-posting-to-hive-blockchain">
                <Button className="tw-normal-case" variant="outlined">
                  Learn about Hive benefits
                </Button>
              </a>
            </div>
          </div>
        </div>
      </section>
      {!user && (
        <TfHighlights topFill="tw-fill-gray-100 dark:tw-fill-[#232A2E]" />
      )}
      <section className="tw-bg-gray-50 dark:tw-bg-gray-900">
        <div className="postcontent postCardContent postanchors tw-max-w-4xl tw-m-auto tw-py-24 tw-text-gray-800 dark:tw-text-gray-50">
          <MDX code={post.body.code} />
        </div>
      </section>
    </>
  );
}
